import React, { useRef, useState, useEffect } from 'react';
import './heroSection.css';
import Vue from './assets/vu.jpg';
import { useNavigate } from 'react-router-dom';
import { GiRapidshareArrow } from "react-icons/gi";

const HeroSection = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  const handleReservationClick = () => {
    navigate('/Reservation');
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio >= 0.8) {
          setIsVisible(true);
          observer.disconnect(); // Stop une fois déclenché
        }
      },
      {
        threshold: Array.from({ length: 101 }, (_, i) => i / 100), // [0, 0.01, ..., 1]
      }
    );
  
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
  
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  

  return (
    <div className="main">
      <div
        className={`welcome-section ${isVisible ? 'animate' : ''}`}
        ref={sectionRef}
      >
        <div
          className="vue-image"
          style={{ backgroundImage: `url(${Vue})` }}
        ></div>
        <div className="content-center">
          <div className="title-animation">
            <div className="title-container">
              <span className="first-title">Un havre de paix à Tichy, Béjaïa</span>
              <span className="second-title">Hôtel Syphax</span>
              <span className="cursor"></span>
            </div>
          </div>
          <p>
          Niché au cœur de la sublime région de Tichy, à Béjaïa...
          Un lieu où le bruit des vagues berce vos rêves et où chaque lever de soleil peint un nouveau souvenir.
         Vivez l’instant, savourez la sérénité… et laissez la magie opérer.
          </p>
          <button className="reserverM" onClick={handleReservationClick}>
            Réserver dès Maintenant <GiRapidshareArrow className="icon-spin" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
